import api from '../services/api';

const BASE = '/study-configuration';

export const fetchLookups = () => api.get(`${BASE}/lookups`);
export const bootstrap = (projectCode) => api.post(`${BASE}/bootstrap`, null, { params: { projectCode } });

export const fetchEmailInfo = () => api.get(`${BASE}/email-info`);
export const saveEmailInfo = (data) => api.post(`${BASE}/email-info`, data);

export const fetchEmailFormats = () => api.get(`${BASE}/email-formats`);
export const createEmailFormat = (data) => api.post(`${BASE}/email-formats`, data);
export const updateEmailFormat = (id, data) => api.post(`${BASE}/email-formats/${id}`, data);

export const fetchActivities = () => api.get(`${BASE}/activities`);
export const createActivity = (data) => api.post(`${BASE}/activities`, data);
export const updateActivity = (id, data) => api.post(`${BASE}/activities/${id}`, data);

export const fetchEmailMappings = () => api.get(`${BASE}/email-activity-mappings`);
export const createEmailMapping = (data) => api.post(`${BASE}/email-activity-mappings`, data);
export const updateEmailMapping = (id, data) => api.post(`${BASE}/email-activity-mappings/${id}`, data);

export const fetchProfiles = () => api.get(`${BASE}/profiles`);
export const createProfile = (data) => api.post(`${BASE}/profiles`, data);
export const updateProfile = (id, data) => api.post(`${BASE}/profiles/${id}`, data);

export const fetchOperations = () => api.get(`${BASE}/operations`);
export const createOperation = (data) => api.post(`${BASE}/operations`, data);
export const updateOperation = (code, data) => api.post(`${BASE}/operations/${encodeURIComponent(code)}`, data);

export const fetchRoleOperations = (profileCode) => api.get(`${BASE}/role-operations`, { params: { profileCode } });
export const saveRoleOperations = (data) => api.post(`${BASE}/role-operations`, data);

export const fetchStages = (projectCode) => api.get(`${BASE}/stages`, { params: { projectCode } });
export const createStage = (data) => api.post(`${BASE}/stages`, data);
export const updateStage = (id, data) => api.post(`${BASE}/stages/${id}`, data);

export const fetchVisitTypes = () => api.get(`${BASE}/visit-types`);
export const createVisitType = (data) => api.post(`${BASE}/visit-types`, data);
export const updateVisitType = (id, data) => api.post(`${BASE}/visit-types/${id}`, data);

export const fetchExternalApis = () => api.get(`${BASE}/external-apis`);
export const createExternalApi = (data) => api.post(`${BASE}/external-apis`, data);
export const updateExternalApi = (id, data) => api.post(`${BASE}/external-apis/${id}`, data);

export const fetchProjectVisitSelections = (projectCode) =>
  api.get('/SiteVisitAssignment/project-selections', { params: { projectCode } });
export const saveProjectVisitSelections = (data) =>
  api.post('/SiteVisitAssignment/project-selections', data);

export const fetchProfileActivities = (projectCode) => api.get(`${BASE}/profile-activities`, { params: { projectCode } });
export const saveProfileActivity = (data) => api.post(`${BASE}/profile-activities`, data);

export const fetchProfileActivityStages = (projectCode, profileNo) =>
  api.get(`${BASE}/profile-activity-stages`, { params: { projectCode, profileNo } });
export const saveProfileActivityStages = (projectCode, data) =>
  api.post(`${BASE}/profile-activity-stages`, data, { params: { projectCode } });

export const fetchIssueCategories = () => api.get(`${BASE}/issue-categories`);
export const createIssueCategory = (data) => api.post(`${BASE}/issue-categories`, data);
export const updateIssueCategory = (id, data) => api.post(`${BASE}/issue-categories/${id}`, data);

export const fetchPriorities = () => api.get(`${BASE}/priorities`);
export const createPriority = (data) => api.post(`${BASE}/priorities`, data);
export const updatePriority = (id, data) => api.post(`${BASE}/priorities/${id}`, data);

export const fetchLetterTemplates = (projectCode) =>
  api.get('/letter-templates/list', { params: { projectCode } });
export const saveLetterTemplate = (data) => api.post('/letter-templates', data);
